// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__CSzUy","userMenu":"UserMenu_userMenu__tYyoU","userMenuItem":"UserMenu_userMenuItem__zQ2qe","name":"UserMenu_name__do-tN"};